<div [ngClass]="isSaving?'disabled':''">
    <div class="d-flex flex-row align-items-stretch" *ngIf="seq">
        <div class="d-flex flex-row busy-overlay-parent">
            <div *ngIf="processing" class="font-weight-bold busy-overlay">
                <i class="fa fa-spinner fa-spin mr-2"></i>{{processingTitle}}
            </div>
            <ng-container *ngIf="bRootTestActive">
                <button *ngIf="rootTest.status=='PAUSING'||rootTest.status=='PAUSED'; else notPaused"
                    (click)="resume()" class="btn btn-secondary mr-1 h-100"
                    [disabled]="processing||(rootTestResuming$|async)||(rootTestStopping$|async)">
                    <i class="fa mr-2"
                        [ngClass]="(rootTestResuming$|async)?'fa-spinner fa-spin':'fa-play blink'"
                    >
                    </i>
                    &nbsp;Resume
                </button>
                <ng-template #notPaused>
                    <button (click)="pause()" class="btn btn-secondary mr-1 h-100"
                        [disabled]="processing||!rootTest.pausable||(rootTestPausing$|async)">
                        <i class="fa mr-2"
                            [ngClass]="(rootTestPausing$|async)?'fa-spinner fa-spin':'fa-pause'">
                        </i>
                        Pause
                    </button>
                </ng-template>
            </ng-container>
            <button *ngIf="!bRootTestActive" class="btn btn-secondary mr-1 h-100" (click)="start()"
                [disabled]="processing||bStarting||isSaving||seq.startTime||(testPoint.statusId==6)||(useDialer&&
                (!dialerClientService.dialerService?.bInitialized||haveEnforcedProfileErrors))">
                <i class="pr-1 fa fa-play"></i>&nbsp;Start
            </button>
            <button class="btn btn-secondary mr-1 h-100" (click)="stop()"
                [disabled]="processing||isSaving||(!seq.startTime||seq.stopTime)||seq.userId!=currentUserId">
                <i class="fa fa-stop pr-1"></i>Stop
            </button>
        </div>
        <div class="status-label d-flex flex-column justify-content-center"
            [ngClass]="testPoint|seqToStatusId|taskStatusBorderedCss">
            <div class="my-auto">{{testPoint|seqToStatusId|taskStatusName|titlecase}}</div>
        </div>
        <div class="d-flex flex-wrap pr-3">
            <div class="pr-3">
                <span *ngIf="seq?.startTime" class="gray font-italic pl-2">
                    Start (Local): {{seq.startTime|date:'yyyy-MM-dd HH:mm:ss'}}
                </span>
                <br/>
                <span *ngIf="seq?.stopTime" class="gray font-italic pl-2">
                    Stop (Local): {{seq.stopTime|date:'yyyy-MM-dd HH:mm:ss'}}
                </span>
            </div>
            <div class="gray font-italic pl-1">
                <div *ngIf="seq.startTime">
                    Duration: {{duration|date:'mm:ss'}}
                </div>
                <ng-container *ngIf="testSeqDoc">
                <ng-container *ngrxLet="testSeqData$ as testSeqData">
                <div *ngIf="testSeqDoc && testSeqData.seqid == seq.dialerSeqId; else noTestSeqDoc" class="font-italic">
                    <div *ngIf="(seq.stopTime||rootTest?.status=='PAUSED') && testSeqData.stats?.counts?.missing" class="bg-warning p-1 m-1 mb-0 rounded">
                        {{testSeqData.stats.counts.missing}} call(s) not placed.
                    </div>
                    <div *ngIf="testSeqData.dialer?.status == 'CANCELLED'"
                        class="text-warning font-weight-bold">
                        Test Stopped Manually
                    </div>
                    <div class="d-flex flex-row align-items-center">
                    <div [ngSwitch]="testSeqData.status">
                        <div *ngSwitchCase="'DIALER_SEQ_FINISHED'" class="text-warning font-weight-bold">
                            <i class="fa fa-info-circle mr-1"></i> Not Uploaded
                        </div>
                        <div *ngSwitchCase="'SEQ_FINISHED'" class="text-warning font-weight-bold">
                            <i class="fa fa-info-circle mr-1"></i> Not Uploaded
                        </div>
                        <div *ngSwitchCase="'SERVER_ACCEPTED'" class="text-success font-weight-bold">
                            <i class="fa fa-check mr-1"></i> Uploaded
                        </div>
                        <div *ngSwitchCase="'SERVER_REJECTED'" class="text-danger font-weight-bold">
                            <i class="fa fa-exclamation-triangle mr-1"></i> Rejected
                        </div>
                        <div *ngSwitchCase="'SERVER_ERROR'" class="text-danger font-weight-bold">
                            <i class="fa fa-exclamation-triangle mr-1"></i> Rejected/Error
                        </div>
                        <div *ngSwitchDefault>
                            {{testSeqData.status?.split('_').join(' ')|ucwords}}
                            <div *ngIf="seq.stopTime && !testSeqData.endTime" class="small font-italic text-warning">
                                Dialer results not in sync
                            </div>
                        </div>
                    </div>
                    <button class="ml-2 mr-0 btn small-button btn-secondary"
                        title="View dialer result"
                        (click)="showDialerSeqId(seq,testSeqDoc)">
                        <i class="fa fa-info-circle smaller-text"></i>
                    </button>
                </div>
                </div>
                <ng-template #noTestSeqDoc>
                    <div *ngIf="seq.dialerSeqId" [attr.title]="'Dialer Seq ID: '+seq.dialerSeqId"
                            (dblclick)="showDialerSeqId(seq,testSeqDoc)"
                            role="button" class="text-info font-italic font-weight-bold" >
                        <i class="fa fa-mobile-alt mr-2"></i>{{seq.stopTime?'Dialer used':''}}
                    </div>
                    <div *ngIf="seq.startTime&&!seq.dialerSeqId" class="d-flex flex-row">
                        <div class="fa-stack fa-1x text-secondary" style="margin-top:-4px;margin-left:-10px;">
                            <i class="fas fa-mobile-alt fa-stack-1x"></i>
                            <i class="fas fa-slash fa-stack-1x" style="opacity:.7;color:Tomato"></i>
                        </div>
                        Dialer not used
                    </div>
                </ng-template>
                </ng-container>
                </ng-container>
            </div>
        </div>

        <div *ngIf="seq && !seq.stopTime" class="ml-auto d-flex">
            <div class="ml-3 card font-smaller">
                <div class="d-flex flex-row align-items-center">
                <label class="form-check-inline pl-2 checkbox-label">
                    <input type="checkbox" [(ngModel)]="useBaro"
                        (change)="useBaroChanged()"
                        [disabled]="isSaving||(seq.startTime&&!seq.stopTime)">
                    &nbsp;Baro
                </label>
                <div *ngIf="useBaro && !seq?.stopTime" class="pr-2">
                    <app-barometer></app-barometer>
                  </div>
                </div>
            </div>
            <div class="ml-1 card font-smaller">
                <div class="d-flex flex-row pl-2 align-items-center">
                    <label class="form-check-inline checkbox-label">
                        <input type="checkbox" [(ngModel)]="useDialer"
                            (change)="useDialerChanged()"
                            [disabled]="isSaving||(seq.startTime&&!seq.stopTime)">
                        &nbsp;Dialer
                    </label>
                    <button *ngIf="useDialer&&dialerClientService.dialerService?.bInitialized!==true"
                        class="btn btn-secondary btn-sm m-1" (click)="enableDialer(true)">
                        Enable
                    </button>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="useDialer&&dialerClientService.dialerService.bInitialized&&!(bRootTestActive||processing||bStarting||isSaving||seq.startTime||(testPoint.statusId==6))">
        <ng-container *ngFor="let fieldErrors of profileValidationErrors | values">
            <div *ngFor="let fieldError of fieldErrors" class="{{fieldError.enforce?'text-danger':'text-dark'}} font-italic px-1 mt-1">
                <i class="fa fa-exclamation-triangle {{fieldError.enforce?'text-danger':'text-warning'}} mr-1"></i> {{profileFieldTitles[fieldError.fieldName]||fieldError.fieldName}} {{fieldError.message}}
            </div>
        </ng-container>
    </ng-container>
    <div *ngIf="seq && seq.startTime && !seq.stopTime && seq.dialerSeqId && seq.userId==currentUserId && !dialerClientService.dialerService?.bInitialized"
            class="mt-3 h3 d-flex flex-row justify-content-between">
        <div>
            <i class="fa fa-exclamation-triangle text-warning mr-3"></i>Enable dialer box if attempting to resume.
        </div>
    </div>
    <div *ngIf="(rootTestPausing$|async)"
            class="mt-3 d-flex flex-row justify-content-between">
        <div>
            <i class="fa fa-exclamation-triangle text-warning mr-3"></i>{{rootTest?.status}}
            <ng-container *ngIf="rootTest?.status=='PAUSING'">
                (waiting for active calls to complete)
            </ng-container>
        </div>
    </div>
    <div class="mt-2 mb-0 pr-1 alert alert-danger"
            *ngIf="errorMsg$ | async as errorMsg">
        <div class="d-flex flex-row justify-content-between">
            <div>
                {{errorMsg | shorten:200:'...'}}
            </div>
            <div class="">
                <i class="fa fa-times" role="button" (click)="resetRootTestErrorEmitter()"></i>
            </div>
        </div>
    </div>

</div>
